import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthStateService } from '../../core/services/auth-state.service';

@Directive({ selector: '[appHasRole]' })
export class HasRoleDirective {
  constructor(
    private tpl: TemplateRef<any>,
    private vcr: ViewContainerRef,
    private auth: AuthStateService
  ) {}

  @Input() set appHasRole(roles: string | string[]) {
    let allowed = false;

    if (Array.isArray(roles)) {
      allowed = roles.some(role => this.auth.hasRole(role));
    } else {
      allowed = this.auth.hasRole(roles);
    }

    this.updateView(allowed);
  }

  private updateView(show: boolean) {
    this.vcr.clear();
    if (show) {
      this.vcr.createEmbeddedView(this.tpl);
    }
  }
}
